import axiosInstance from '@/services'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'

export default async function () {
  const globalStore = useGlobalStore()
  const formStore = useFormStore()

  const { serviceTransactionId } = globalStore.startedService
  const { shipNumber } = formStore.form.values
  const path = [
    '',
    'api',
    'trip',
    'request',
    'checkIfShipRegisterd',
    serviceTransactionId,
    shipNumber
  ]
  const response = await axiosInstance.get(path.join('/'))
  if (!response) {
    notify(
      {
        group: 'error',
        title: i18n.t('thisShipAlreadyRegistered'),
        text: i18n.t('registerdShip')
      },
      6000
    )
    return Promise.resolve(false)
  }
  return Promise.resolve(true)
}
